<template>
  <echarts :options="options" class="chart-stage"></echarts>
</template>
<script>
import echarts from "./basic";
import "echarts/lib/chart/bar";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";

export default {
  props: {
    category: {
      type: Array,
      required: true
    },
    data: {
      type: Array,
      required: true
    },
    grid: {
      type: Object,
      default() {
        return {}
      }
    },
    unit: {
      type: String,
      default: ''
    },
    unitX: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      // barColor: ['#ff7c79', '#f19149', '#22ac38','#00a0e9', "#9b66e6", "#ffd451"],
      barColor: [],
      dataColor:[
        {
          name:this.$t("device.generated"),
          color:'#ff7c79'
        },
                {
          name:this.$t("device.bought"),
          color:'#f19149'
        },
                {
          name:this.$t("device.sold"),
          color:'#22ac38'
        },
                {
          name:this.$t("device.charged"),
          color:'#00a0e9'
        },
                {
          name:this.$t("device.discharged"),
          color:'#9b66e6'
        },
                {
          name:this.$t("device.used"),
          color:'#ffd451'
        }
      ]
    }
  },
  created() {
    var array = []
    this.data.forEach(element => {
      this.dataColor.forEach(elementItem => {
        if(element.name==elementItem.name){
          array.push(elementItem.color)
        }
      });
    });
    this.barColor = array
  },
  computed: {
    options() {
      // console.log("this.data柱形",this.data)
      // console.log("this.category",this.category)
      let series = [], legends = []
      this.data.forEach(ele => {
        legends.push(ele.name)
        series.push({
          name: ele.name,
          type: 'bar',
          data: ele.value
        })
      })
      let grid = {
        ...{
          top: "45",
          left: "60",
          right: "30",
          bottom: "55"
        }, ...this.grid
      }
      return {
        color: this.barColor,
        tooltip: {
          trigger: "axis",
          backgroundColor: "#fff",
          borderColor: "#eee",
          borderWidth: "1",
          textStyle: {
            color: '#666',
            fontSize: 12
          },
          axisPointer: {
            type: "shadow"
          }
        },
        legend: {
          bottom: '0',
          data: this.legend
        },
        grid,
        xAxis: [
          {
            type: "category",
            name: this.unitX,
            data: this.category,
            axisLine: {
              lineStyle: {
                color: '#aaa'
              }
            },
            axisLabel: {
              color: '#666'
            },
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            name: this.unit,
            axisLine: {
              lineStyle: {
                color: '#aaa'
              }
            },
            axisLabel: {
              color: '#666'
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: '#ddd'
              }
            }
          }
        ],
        series
      }
    }
  },
  components: {
    echarts
  }
};
</script>
<style lang="less" scoped>
.chart-stage {
  height: 100%;
}
</style>


